import React from 'react';

import Statistic, { StatisticProps } from '@components/Statistic';

const statistics: StatisticProps[] = [
  { statistic: '37', cadence: 'awards', definition: 'for exceptional reporting' },
  {
    statistic: '700K',
    cadence: 'users',
    definition: 'active readers across tech, finance and business',
  },
  { statistic: '23', cadence: '%', definition: 'annual revenue growth' },
  { statistic: '73', cadence: 'total staff', definition: 'including 41 reporters and editors' },
];

const Statistics = () => {
  return (
    <section className="lg:mb-150px] mb-72 flex flex-wrap items-start gap-x-12 gap-y-48 sm:mb-80 sm:items-center sm:gap-80 md:mb-[136px] lg:justify-between lg:gap-0">
      {statistics.map((stat, index) => (
        <Statistic key={index} {...stat} />
      ))}
    </section>
  );
};

export default Statistics;
